import React from 'react';

function Cart(props) {

    const {quantity = 0, handlBasjedShow = Function.prototype} = props;
    return (
        <div className="cart blue darken-4 white-text" onClick={handlBasjedShow}>
            <i className="large material-icons">add_shopping_cart</i>
            {quantity ? <span className="cart-quantity">{quantity}</span> : null}
        </div>
    );
}

export default Cart;